<ion-card>
  <ion-grid>
    <ion-row>
      <ion-col col-6>
        <div id="card-logo" [ngSwitch]="article.newspaper_id.subname">
          <img *ngSwitchCase="'mquo'"  src="/../assets/img/monq-logo.png" class="MQ_Logo">
          <img *ngSwitchCase="'lepq'" src="/../assets/img/petitq-logo.png" class="LPQ_Logo">
          <img *ngSwitchCase="'actu'" src="/../assets/img/actulogo.png" class="MQ_Logo">
          <img *ngSwitchCase="'acne'" src="/../assets/img/acnelogo.png" class="MQ_Logo">
          <img *ngSwitchCase="'aeco'" src="/../assets/img/eco_logo_article.svg" class="ECHO_Logo">
          <img *ngSwitchCase="'mlwk'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
          <img *ngSwitchCase="'mlne'" src="/../assets/img/my-little-weekly-news_logo_article.svg" class="LPQ_Logo">
          <img *ngSwitchCase="'mljp'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
          <img *ngSwitchCase="'mlde'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
          <img *ngSwitchCase="'week'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
          <img *ngSwitchCase="'mwne'" src="/../assets/img/my-weekly-news_logo_article.svg" class="MW_Logo">
          <img *ngSwitchCase="'mwjp'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
          <img *ngSwitchCase="'mwde'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
          <img *ngSwitchCase="'woch'" src="/../assets/img/meine-woche_logo_article.svg" class="WOCH_Logo">
          <img *ngSwitchCase="'sema'" src="/../assets/img/mi-seminal_logo_article.svg" class="WOCH_Logo">
          <img *ngSwitchCase="'mquovideo'" src="/../assets/logos/mon-quotidien-video_logo_article.svg" class="WOCH_Logo">
          <img *ngSwitchCase="'actuvideo'" src="/../assets/logos/actu-video_logo_pour fond blanc.svg" class="WOCH_Logo">
          <img *ngSwitchCase="'clfy'" src="/../assets/logos/clarify_logo_article.svg" class="WOCH_Logo">
          <img *ngSwitchCase="'play'" src="/../assets/logos/pbp-logo_lesson.svg" class="WOCH_Logo">
          <img *ngSwitchCase="'frigobloc'" src="/../assets/logos/frigobloc.png" class="WOCH_Logo frigobloc">
        </div>
      </ion-col>
       <ion-col col-6 style="text-align: right;">
       <div id="card-pubdate" *ngIf="article.publish_on">{{article.publish_on | date:'d/M/y':'':'fr'}}</div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="rule-logo"></div>
  <ion-card-content>
  <div [ngClass]= "{'article-detail-category-title-container': true, 'article.newspaper_subname': true}">
    <span [ngClass]= "{'article-category': true, 'mquo': article.newspaper_subname === 'mquo',
    'lepq': article.newspaper_subname === 'lepq', 'actu': article.newspaper_subname === 'actu',
      'aeco': article.newspaper_subname === 'aeco', 'mlwk': article.newspaper_subname === 'mlwk',
      'mlne': article.newspaper_subname === 'mlne', 'mwne': article.newspaper_subname === 'mwne',
      'week': article.newspaper_subname === 'week' || article.newspaper_subname === 'mwjp' || article.newspaper_subname === 'mwde',
      'woch': article.newspaper_subname === 'woch','sema': article.newspaper_subname === 'sema'}" *ngIf="article.article_category">
      {{article.article_category}}
    </span>
    <div class="clear"></div>
    <h2 class="searchh2" (click)="navigateToDetailSearch(article.slug, article.type, article.is_free, article.id)">
      {{article.title}}
    </h2>
  </div>
  <span class="author" *ngIf="article.article_author">{{article.article_author}}</span>
  <div class="article-list-image" *ngIf="article.image_url"><img src="{{article.image_url}}"></div>


    <div class="article-content" *ngIf="article.isOpen" [innerHTML]="article.content">
    </div>
    <div class="article-content-excerpt" *ngIf="article.content_excerpt" [innerHTML]="article.content_excerpt">
    </div>

      <span class="readmore" *ngIf="article.readmore === 2">

        <span class="read-more"><ion-icon class="read-article"></ion-icon>{{'TIMELINE.ARTICLE.LINK' | translate}}</span>
      </span>

    <span class="readmore" *ngIf="article.readmore === 1" (click)="article.isOpen = !article.isOpen">
      <span class="read-more"><ion-icon class="opencard"></ion-icon>{{'TIMELINE.ARTICLE.READ_MORE.EXTEND' | translate}}</span>
    </span>
  </ion-card-content>

  <ion-row>
    <ion-col class="home-card-sides-search">
        <div class="card-footer-search" *ngIf="article.type === 'article'">
          <ion-icon class="journeaux"></ion-icon>
          <span class="card-footer-text-search">{{'SEARCH.ARTICLE' | translate}}</span>
        </div>
        <div class="card-footer-search" *ngIf="article.type === 'factsheet'">
          <ion-icon class="copy"></ion-icon>
          <span class="card-footer-text-search">Exposé</span>
        </div>
        <div class="card-footer-search" *ngIf="article.type === 'dossier'">
          <ion-icon class="dossiers ion-item-left"></ion-icon>
          <span class="card-footer-text">Dossier Thematique</span>
        </div>
    </ion-col>
  </ion-row>
</ion-card>
